import { ObservableArray, View, ViewModel } from "binder"
import { ControlPlanReportViewModel, SingleRow } from "./controlPlanReport-viewModel"
import { ServerSideDataLoader } from "uicomponents";

export class ControlPlanReportView extends View<ControlPlanReportViewModel>{
    GetViewUniqueId(): string {
        return "V-02F53775-4ECF-41C7-ACA8-0219C9CEF129"
    }
    loadHtml(): string {
        let element = require('./controlPlanReport.html').default;
        let style = require('./controlPlanReport.less');
        return element;
    }
    constructor() {
       super();
    }

    public set rows(v: ObservableArray<SingleRow>) { this._rows = v; } public get rows(): ObservableArray<SingleRow> { return this._rows;} private _rows: ObservableArray<SingleRow>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    
}
